import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
// reactstrap components
import { ModalBody, Modal, ModalHeader, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import {
  IToolbarContentConfig,
  IToolbarLanguageConfig,
} from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import NoteButtonsContainer from "../containers/NoteButtonsContainer";
import LanguageDropdown from "../dropdowns/LanguageDropdown";

interface IParams {
  languageSelectionConfig: IToolbarLanguageConfig | undefined;
  contentConfig: IToolbarContentConfig | undefined;
}

const HomeMobileModal: React.FC<IParams> = ({
  languageSelectionConfig,
  contentConfig,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { showHomeModal, setHomeModalOpen } = rootStore.responsiveStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const {
    toolbar,
    currentBrowsePageContent,
    currentGalleryPage,
    setGalleryPage,
  } = rootStore.commonStore;

  const handleLanguageSelect = (goToPageIndex: number, languageId?: number) => {
    if (languageSelectionConfig)
      languageSelectionConfig
        .changeLanguage(languageId)
        .then((newTotalItems) => setGalleryPage(goToPageIndex, newTotalItems));
  };

  return (
    <>
      <Modal
        isOpen={showHomeModal}
        toggle={() => setHomeModalOpen(!showHomeModal)}
        className={classNames("homeModal modal-dialog-centered ")}
        contentClassName="customHomeModalContent "
      >
        <ModalHeader
          className={classNames(
            "homeModalHeader ",
            theme!.headerColor,
            theme!.headerTextColor
          )}
          toggle={() => setHomeModalOpen(!showHomeModal)}
          close={
            <button
              className={classNames(
                "closeHomeModalIcon",
                theme!.headerTextColor
              )}
              onClick={() => setHomeModalOpen(!showHomeModal)}
            >
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
        >
          {t("mobilehome_modal_title")}
        </ModalHeader>
        <ModalBody className="customHomeModal ">
          <Row>
            {contentConfig && contentConfig.enableNotes && toolbar && (
              <NoteButtonsContainer buttons={toolbar!.noteButtons} />
            )}
          </Row>
          <hr />
          {languageSelectionConfig &&
            currentBrowsePageContent &&
            currentBrowsePageContent.languages &&
            currentBrowsePageContent.languages.availabeLanguages.length > 1 && (
              <LanguageDropdown
                languages={currentBrowsePageContent.languages.availabeLanguages}
                selectedLanguage={currentBrowsePageContent.languages.languageId}
                onLanguageSelect={(l) =>
                  handleLanguageSelect(currentGalleryPage, l)
                }
                direction="down"
                flagFontSize={30}
              />
            )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(HomeMobileModal);
